import { Roles } from 'clickNgo/configs/roles'

export const SINGLE_CATEGORY_CRUD_PROPS = {
  keyField: 'Code',
  hierarchyField: 'ParentCode',
  captionField: 'Title',
} as const

export const READ_ONLY_ROLE = Roles.EXCEPTION_READ_ONLY
export const SUBMIT_ALLOWED_ROLES = [Roles.SUPER_ADMIN_ROLE, Roles.EXCEPTION_USER]
export const BUSINESS_UNITS = ['PS', 'PC', 'Print', 'Supplies', 'Poly', 'Peripherals']
export const MAX_CATEGORIES_IN_BUSINESS_UNIT = 1
